import React from 'react';
import { Table, OverlayTrigger, Tooltip, Dropdown, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './WorkloadTable.css';

const WorkloadTable = ({
    onEdit,
    onView,
    onViewHistory,
    onDelete,
    onContactClick,
    expandedRows,
    onToggleRow
}) => {
    const toggleRow = (index) => {
        onToggleRow?.(index);
    };
    return (
        <Table responsive className='c-table'>
            <thead>
                <tr>
                    <th width="300px" className='text-nowrap'>
                        <Button variant='outline-primary' className='btn-sm me-2 text-nowrap'>
                            Expand All
                        </Button>
                        <Button variant='primary' className='btn-sm me-2 text-nowrap'>
                            Today
                        </Button>
                    </th>
                    <th className='bg-white p-0'>
                        <div className='workload-table'>
                            <div className='workload-col flex-column text-center py-2'>Mon<br/><span className='fw-bold'>Sep - 01</span></div>
                            <div className='workload-col flex-column text-center py-2'>Tue<br/><span className='fw-bold'>Sep - 02</span></div>
                            <div className='workload-col flex-column text-center py-2'>Wed<br/><span className='fw-bold'>Sep - 03</span></div>
                            <div className='workload-col flex-column text-center py-2'>Thu<br/><span className='fw-bold'>Sep - 04</span></div>
                            <div className='workload-col flex-column text-center py-2'>Fri<br/><span className='fw-bold'>Sep - 05</span></div>
                            <div className='workload-col flex-column text-center py-2 woff'>Sat<br/><span className='fw-bold'>Sep - 06</span></div>
                            <div className='workload-col flex-column text-center py-2 woff'>Sun<br/><span className='fw-bold'>Sep - 07</span></div>
                            <div className='workload-col flex-column text-center py-2'>Mon<br/><span className='fw-bold'>Sep - 08</span></div>
                            <div className='workload-col flex-column text-center py-2'>Tue<br/><span className='fw-bold'>Sep - 09</span></div>
                            <div className='workload-col flex-column text-center py-2'>Wed<br/><span className='fw-bold'>Sep - 10</span></div>
                            <div className='workload-col flex-column text-center py-2'>Thu<br/><span className='fw-bold'>Sep - 11</span></div>
                            <div className='workload-col flex-column text-center py-2'>Fri<br/><span className='fw-bold'>Sep - 12</span></div>
                            <div className='workload-col flex-column text-center py-2 woff'>Sat<br/><span className='fw-bold'>Sep - 13</span></div>
                            <div className='workload-col flex-column text-center py-2 woff'>Sun<br/><span className='fw-bold'>Sep - 14</span></div>
                            <div className='workload-col flex-column text-center py-2'>Mon<br/><span className='fw-bold'>Sep - 15</span></div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {[...Array(5)].map((_, i) => (
                    <React.Fragment key={i}>
                        <tr>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <Button variant="link" className='me-3' onClick={() => toggleRow(i)}>
                                        <i className={`fas fa-chevron-${expandedRows.has(i) ? 'down' : 'right'}`}></i>
                                    </Button>
                                    <div className='d-flex align-items-center'>
                                        <div className='c-avatar'>
                                            <img src='https://randomuser.me/api/portraits/men/32.jpg' alt='Avatar' />
                                        </div>
                                        <div>
                                            <div className='p-tag fw-bold text-nowrap'>John Doe</div>
                                            <div className='p-tag fs-12 text-nowrap'>Role: Team Lead</div>
                                            <div className='p-tag fs-12 text-nowrap'>Department: Marketing</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className='p-0'>
                                <div className='workload-table'>
                                    <div className='workload-col text-center fw-bold'>
                                        <div className='work' style={{ background: 'linear-gradient(180deg,rgba(255, 208, 218, 0) 0%, rgba(255, 208, 218, 1) 0%)' }}>8h</div>
                                    </div>
                                    <div className='workload-col text-center fw-bold'>
                                        <div className='work' style={{ background: 'linear-gradient(180deg,rgba(255, 208, 218, 0) 0%, rgba(255, 208, 218, 1) 0%)' }}>8h</div>
                                    </div>
                                    <div className='workload-col text-center fw-bold'>
                                        <div className='work' style={{ background: 'linear-gradient(180deg,rgba(255, 208, 218, 0) 0%, rgba(255, 208, 218, 1) 0%)' }}>8h</div>
                                    </div>
                                    <div className='workload-col text-center fw-bold'>
                                        <div className='work' style={{ background: 'linear-gradient(180deg,rgba(255, 208, 218, 0) 0%, rgba(255, 208, 218, 1) 0%)' }}>8h</div>
                                    </div>
                                    <div className='workload-col text-center fw-bold'>
                                        <div className='work' style={{ background: 'linear-gradient(180deg,rgba(216, 224, 255, 0) 50%, rgba(216, 224, 255, 1) 50%)' }}>5h</div>
                                    </div>
                                    <div className='workload-col text-center woff'>WOFF</div>
                                    <div className='workload-col text-center woff'>WOFF</div>
                                    <div className='workload-col text-center fw-bold'>0h</div>
                                    <div className='workload-col text-center fw-bold'>0h</div>
                                    <div className='workload-col text-center fw-bold'>0h</div>
                                    <div className='workload-col text-center fw-bold'>0h</div>
                                    <div className='workload-col text-center fw-bold'>0h</div>
                                    <div className='workload-col text-center woff'>WOFF</div>
                                    <div className='workload-col text-center woff'>WOFF</div>
                                    <div className='workload-col text-center fw-bold'>0h</div>
                                </div>
                            </td>
                        </tr>

                        {expandedRows.has(i) && (
                            <>
                                {[...Array(1)].map((_, i) => (
                                    <React.Fragment key={i}>
                                        <tr className='sub-row'>
                                            <td>
                                                <div class="p-tag fw-bold">Resource Management</div>
                                                <div class="p-tag fs-12">Total Task: 500/1000</div>
                                            </td>
                                            <td className='p-0'>
                                                <div className='workload-table'>
                                                    <div className='workload-col'>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 4h</div>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 4h</div>
                                                    </div>
                                                    <div className='workload-col'>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 7h</div>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 1h</div>
                                                    </div>
                                                    <div className='workload-col'>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 7h</div>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 1h</div>
                                                    </div>
                                                    <div className='workload-col'>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 7h</div>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 1h</div>
                                                    </div>
                                                    <div className='workload-col'>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 4h</div>
                                                        <div className='task text-truncate'>Conduct UI Research <br/> 1h</div>
                                                    </div>
                                                    <div className='workload-col woff'></div>
                                                    <div className='workload-col woff'></div>
                                                    <div className='workload-col'></div>
                                                    <div className='workload-col'></div>
                                                    <div className='workload-col'></div>
                                                    <div className='workload-col'></div>
                                                    <div className='workload-col'></div>
                                                    <div className='workload-col woff'></div>
                                                    <div className='workload-col woff'></div>
                                                    <div className='workload-col'></div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className='sub-row'>
                                            <td>Add Task</td>
                                            <td className='p-0'>
                                                <div className='workload-table'>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center woff'></div>
                                                    <div className='workload-col text-center woff'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center'></div>
                                                    <div className='workload-col text-center woff'></div>
                                                    <div className='workload-col text-center woff'></div>
                                                    <div className='workload-col text-center'></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default WorkloadTable;
